import React from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import MainLayout  from './layouts/mainLayout';
import AuthLayout from './layouts/authLayout';
import Login from './modules/login';
import HomePage from './modules/home';
import CustomerPage from './modules/customer';
import CustomerDetailPage from './modules/customer/customerDetailPage';
import CustomerImportPage from './modules/customer/customerImportPage';
import ProductPage from "./modules/product";
import ProductImportPage from './modules/product/productImportPage';
import SubscriptionPage from './modules/subscription';
import InvoicePage from "./modules/invoice";
import GenerateInvoice from "./modules/invoice/GenerateInvoice";
import SubscriptionForm from "./modules/subscription/components/subscriptionForm";
import SettingsPage from './modules/settings';
import InvoiceConfig from './modules/settings/invoiceConfig';
import RolesPermissions from './modules/settings/roles';
import ProfileSettings from './modules/settings/profile';
import ProtectedRoute from './auth/ProtectedRoute';
import AvalaraSettings from './modules/settings/avalaraSettings';

const router = createBrowserRouter([
  {
    path: '/login',
    element: (
    <AuthLayout>
      <Login />
    </AuthLayout>
  ),
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <MainLayout />
      </ProtectedRoute>
    ),
    children: [
      // Redirect / to /home
      { index: true, element: <Navigate to="home" replace /> },

      { path: 'home', element: <HomePage /> },
      { path: 'customers', element: <CustomerPage /> },
      { path: 'customers/:id', element: <CustomerDetailPage /> },
      { path: 'customers/import', element: <CustomerImportPage /> },
      { path: 'products', element: <ProductPage /> },
      { path: 'products/import', element: <ProductImportPage /> },
      { path: 'subscriptions', element: <SubscriptionPage /> },
      { path: 'invoices', element: <InvoicePage /> },
      { path: 'generate-invoice', element: <GenerateInvoice /> },
      { path: 'subscriptions/add', element: <SubscriptionForm mode="add" /> },
      { path: 'subscriptions/edit/:id', element: <SubscriptionForm mode="edit" /> },
      { path: 'settings', element: <SettingsPage /> },
      { path: 'settings/invoice-configurations', element: <InvoiceConfig /> },
      { path: 'settings/roles-permissions', element: <RolesPermissions /> },
      { path: 'settings/profile', element: <ProfileSettings /> },
      { path: 'settings/avalara', element: <AvalaraSettings /> },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
]);

export default router;